import { makeErrorField } from '../../../../helpers';
import FieldModel from '../../../../models/FieldModel';
import { registrarEmailsProcesso } from '../../../../services/core/processos/processosService';

class DialogEmailController {
  makeFormFields() {
    return {
      email: new FieldModel({
        name: 'email',
        value: '',
      }),
    };
  }

  makeErrorFields() {
    return {
      email: makeErrorField(),
    };
  }

  async registrarEmail(idProcesso, formFields) {
    const emailValue = formFields.email.value || formFields.email;
    if (!emailValue || emailValue.trim() === '') {
      throw new Error('Email é obrigatório');
    }
    return registrarEmailsProcesso(idProcesso, emailValue);
  }
}

export const dialogEmailController = new DialogEmailController();
